import statusApi from '@/services/API/status'



const fetchSalesOrderStatuses = function({ commit, state}) {
  if(state.salesOrderStatusesOutDated){
    return statusApi.fetchStatusesByType('SALES_ORDER').then(salesOrderStatuses => {
      commit('SET_SALES_ORDER_STATUSES', salesOrderStatuses);
    });
  }
};

const fetchPurchaseOrderStatuses = function({ commit, state }) {
  if(state.purchaseOrderStatusesOutDated){
    return statusApi.fetchStatusesByType('PURCHASE_ORDER').then(purchaseOrderStatuses => {
      commit('SET_PURCHASE_ORDER_STATUSES', purchaseOrderStatuses);
    });
  }
};

const fetchInvoiceStatuses = function({ commit, state }) {
  if(state.invoiceStatusesOutDated){
    return statusApi.fetchStatusesByType('INVOICE').then(invoiceStatuses => {
      commit('SET_INVOICE_STATUSES', invoiceStatuses);
    });
  }
};
const fetchInvoiceNoticeStatuses = function({ commit, state }) {
  if(state.invoiceNoticeStatusesOutDated){
    return statusApi.fetchStatusesByType('INVOICE_NOTICE').then(invoiceNoticeStatuses => {
      commit('SET_INVOICE_NOTICE_STATUSES', invoiceNoticeStatuses);
    });
  }
};


const fetchPackageStatuses = function({ commit, state }) {
  if(state.packageStatusesOutDated){
    return statusApi.fetchStatusesByType('PACKAGE').then(packageStatuses => {
      commit('SET_PACKAGE_STATUSES', packageStatuses);
    });
  }else {
    return Promise.resolve();
  }
};

const fetchCreditStatuses = function({ commit, state }) {
  if(state.creditNoteStatusesOutDated){
    return statusApi.fetchStatusesByType('CREDIT_NOTE').then(creditNoteStatuses => {
      commit('SET_CREDIT_NOTE_STATUSES', creditNoteStatuses);
    });
  }else {
    return Promise.resolve();
  }
};



/* istanbul ignore next line */
const reset = function({ commit }) {
  commit('RESET_STATE');
};

export default {
  fetchSalesOrderStatuses,
  fetchPurchaseOrderStatuses,
  fetchInvoiceStatuses,
  fetchInvoiceNoticeStatuses,
  fetchPackageStatuses,
  fetchCreditStatuses,
  reset
};
